
import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { FaEdit, FaTrash } from 'react-icons/fa';
import ClientModal from './ClientModal';
import ReactPaginate from 'react-paginate';
import { Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import withPermission from '../../utils/withPermission';
import Swal from 'sweetalert2';
import { useLocation } from 'react-router-dom';
import ClientDetails from './ClientDetails';

const ClientList = ({ type }) => {
    const [contacts, setContacts] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [selectedContactId, setSelectedContactId] = useState(null);
    const [selectedContactData, setSelectedContactData] = useState(null);
    const [currentPage, setCurrentPage] = useState(0);
    const [pageCount, setPageCount] = useState(0);
    const [countries, setCountries] = useState([]);
    const [errors, setErrors] = useState({});
    const [searchQuery, setSearchQuery] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const didFetchRef = useRef(false);

    const contactType = type;
    const WithEditPermission = withPermission(({ children }) => children, [`${contactType}-edit`]);
    const WithCreatePermission = withPermission(({ children }) => children, [`${contactType}-create`]);
    const WithDeletePermission = withPermission(({ children }) => children, [`${contactType}-delete`]);
    const debounceTimeoutRef = useRef(null);


    const didInitialFetch = useRef(false);
    const activeType = useRef(type);
    //     useEffect(() => {
    //         const fetchData = async () => {
    //             await fetchContacts(1);
    //         };
    //         if (!didInitialFetch.current || activeType.current !== type) {
    //             didInitialFetch.current = true;
    //             activeType.current = type;
    //             fetchData();
    //         }
    //     }, [type]);
    const location = useLocation(); // Get current URL
    const searchParams = new URLSearchParams(location.search);
    const isSalesPage = searchParams.get("sales") === "true";


    useEffect(() => {
        const fetchData = async () => {
            if (!didInitialFetch.current) {
                didInitialFetch.current = true;
                await fetchContacts(1);
            } else {
                if (debounceTimeoutRef.current) {
                    clearTimeout(debounceTimeoutRef.current);
                }
                debounceTimeoutRef.current = setTimeout(() => {
                    fetchContacts(1, searchQuery, isSalesPage);
                }, searchQuery ? 1500 : 0);
            }
        };

        fetchData();

        return () => {
            if (debounceTimeoutRef.current) {
                clearTimeout(debounceTimeoutRef.current);
            }
        };
    }, [searchQuery, contactType, location.search]);

    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);

    };
    const fetchCountries = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.get(`${backendUrl}/api/countries`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,

                },
                skipLoader: true,
            });
            setCountries(response.data.Data);
        } catch (error) {
            console.error('Error fetching countries:', error);
        }
    };

    const fetchContacts = async (page = 1) => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const params = {
                page: page,
                search: searchQuery,
                issales: isSalesPage ? "true" : "false",  // Dynamically set issales
            };
            const response = await axios.get(`${backendUrl}/api/contacts?type=${contactType}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,

                },
                params: params,
            });

            const { data, current_page, last_page } = response.data.Data;

            setContacts(data);
            setCurrentPage(current_page - 1);
            setPageCount(last_page);
        } catch (error) {
            console.error(`Error fetching ${contactType}:`, error);
        }
    };
    const fetchAllSalesClients = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            let allSalesClients = [];
            let page = 1;
            let lastPage = 1;

            do {
                const params = {
                    page: page,
                    issales: "true",
                };

                const response = await axios.get(`${backendUrl}/api/contacts?type=${contactType}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Tenant-Origin': origin,

                    },
                    params: params,
                    skipLoader:true,
                });

                const { data, last_page } = response.data.Data;
                allSalesClients = [...allSalesClients, ...data];
                lastPage = last_page;
                page++;

            } while (page <= lastPage);

            return allSalesClients; // Return all sales clients but don't update UI
        } catch (error) {
            console.error("Error fetching all sales clients:", error);
            return [];
        }
    };

const Toast = Swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
            toast.onmouseenter = Swal.stopTimer;
            toast.onmouseleave = Swal.resumeTimer;
        },
    });
    const addContact = async (newContact) => {
        try {
            console.log("Contacts:", contacts);
            const allSalesClients = await fetchAllSalesClients();

            console.log('All Sales Clients:', allSalesClients);

            // Check if the new contact's name already exists in sales clients
            const isDuplicate = allSalesClients.some(client =>
                client.name.trim().toLowerCase() === newContact.name.trim().toLowerCase()
            );
            if (isDuplicate) {
                Swal.fire({
                    toast: true,
                    position: 'top-end',
                    icon: 'warning',
                    title: 'The client is already added in the sales record!',
                    timer: 3000,
                    timerProgressBar: false,
                    showConfirmButton: false,
                    didOpen: () => {
                        const container = Swal.getContainer();
                        container.style.top = '50px';
                    },
                });
                return; // Prevent adding the client
            }
            const formData = new FormData();
            // Append regular fields
            Object.keys(newContact).forEach((key) => {
                if (key === 'rcm_eligible' && (newContact[key] === null || newContact[key] === undefined || newContact[key] === '')) {
                    return;
                }
                formData.append(key, newContact[key]);
            });
            if (isSalesPage) {
                formData.append('issales', 'true');
            }

            if (newContact.avatar) {
                formData.append('avatar', newContact.avatar);
            }

            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.post(`${backendUrl}/api/contacts?type=${contactType}`, formData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'multipart/form-data',
                    'Tenant-Origin': origin,

                },
                skipLoader:true,
            });
            const createdContact = response.data.Data;

            if (createdContact) {
                setContacts((prevContacts) => [...prevContacts, createdContact]);
            } else {
                console.error('Creation failed, no data returned.');
            }

            handleCloseModal();
                        Toast.fire({ icon: "success", title: "Added successfully!" });

        } catch (error) {
            if (error.response?.data?.errors) {
                return error.response.data.errors; // Return validation errors
            } else {

                console.error(`Error adding ${contactType}:`, error);
            }
        }
    };

    const editContact = async (contactId, updatedData) => {
        try {
            const formData = new FormData();

            Object.keys(updatedData).forEach((key) => {
                if (key === "avatar" && typeof updatedData[key] === "string") {
                    // Only add avatar as a file if it's a new upload
                    return;
                }
                if (key === 'rcm_eligible' && (updatedData[key] === null || updatedData[key] === undefined || updatedData[key] === '')) {
                    return;
                }
                formData.append(key, updatedData[key]);
            });

            if (updatedData.avatar instanceof File) {
                formData.append('avatar', updatedData.avatar); // Only append if it's a valid image file upload
            }


            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');

            const token = userInfo?.token;

            const response = await axios.post(`${backendUrl}/api/contacts/${contactId}?_method=PUT&type=${contactType}`, formData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'multipart/form-data',
                    'Tenant-Origin': origin,

                },
            });
            const updatedContact = response.data.Data;

            if (updatedContact) {
                setContacts((prevContacts) =>
                    prevContacts.map((contact) => (contact.id === updatedContact.id ? updatedContact : contact))
                );
            } else {
                console.error('Update failed, no data returned.');
            }

            handleCloseModal();
        } catch (error) {
            if (error.response?.data?.errors) {
                return error.response.data.errors; // Return validation errors
            } else
                console.error(`Error updating ${contactType}:`, error);
        }
    };




    const deleteContact = async (id) => {
        Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Yes, delete it!"
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const backendUrl = process.env.REACT_APP_BACKEND_URL;
                    const userInfo = JSON.parse(localStorage.getItem('user-info'));
                    const origin = localStorage.getItem('user-origin');

                    const token = userInfo?.token;

                    await axios.delete(`${backendUrl}/api/contacts/${id}?type=${contactType}`, {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            'Tenant-Origin': origin,

                        },

                    });
                    let storedClients = JSON.parse(localStorage.getItem('clients')) || [];
                    storedClients = storedClients.filter(client => client.id !== id);
                    localStorage.setItem('clients', JSON.stringify(storedClients));

                    // ✅ Update deals that had this client
                    let storedDeals = JSON.parse(localStorage.getItem('deals')) || [];
                    storedDeals = storedDeals.map(deal =>
                        deal.client_id === id ? { ...deal, client_id: null } : deal
                    );
                    localStorage.setItem('deals', JSON.stringify(storedDeals));
                    setContacts(contacts.filter((contact) => contact.id !== id));
                    Swal.fire(
                        "Deleted!",
                        "The client has been deleted.",
                        "success"
                    );
                } catch (error) {
                    console.error('Error deleting client:', error);
                    Swal.fire(
                        "Error!",
                        "Failed to delete client. Please try again.",
                        "error"
                    );
                }
            }
        });

    };

    const handleShowModal = (contactId = null) => {
        if (contactId) {
            const contactToEdit = contacts.find((contact) => contact.id === contactId);
            if (contactToEdit) {
                setSelectedContactData(contactToEdit);
            }
        } else {
            setSelectedContactData(null);
        }
        setSelectedContactId(contactId);
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setSelectedContactId(null);
        setSelectedContactData(null);
        setErrors({});

    };

    const handlePageClick = (data) => {
        const selectedPage = data.selected + 1;
        fetchContacts(selectedPage);
    };

    const [showLeadOffcanvas, setShowLeadOffcanvas] = useState(false);

    const handleShowLeadDetails = (leadId) => {
        setSelectedContactId(leadId);
        setShowLeadOffcanvas(true);
    };

    const handleCloseLeadDetails = () => {
        setShowLeadOffcanvas(false);
        setSelectedContactId(null);
    };

    const handleImport = async (event) => {
        const file = event.target.files[0];
        if (!file) return;

        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const formData = new FormData();
            formData.append('file', file);

            const response = await axios.post(
                `${backendUrl}/api/${contactType}/import`,
                formData,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'multipart/form-data',
                        'Tenant-Origin': origin,
                    },
                }
            );

            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'success',
                title: response.data.message || `${contactType.charAt(0).toUpperCase() + contactType.slice(1)}s imported successfully!`,
                timer: 3000,
                timerProgressBar: false,
                showConfirmButton: false,
                didOpen: () => {
                    const container = Swal.getContainer();
                    container.style.top = '50px';
                },
            });
 setTimeout(() => window.location.reload(), 1500);

            // Clear the file input
            event.target.value = '';
        } catch (error) {
            console.error('Import error:', error);
            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'error',
                title: error.response?.data?.message || `Failed to import ${contactType}s`,
                timer: 3000,
                timerProgressBar: false,
                showConfirmButton: false,
                didOpen: () => {
                    const container = Swal.getContainer();
                    container.style.top = '50px';
                },
            });
                        event.target.value = '';

        } finally {
        }
    };

    // Export Functions
    const handleExport = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.get(
                `${backendUrl}/api/${contactType}/export`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Tenant-Origin': origin,
                    },
                    responseType: 'blob', // Important for file download
                }
            );

            // Create blob link and download
            const blob = new Blob([response.data]);
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;

            // Get filename from response headers or use default
            const contentDisposition = response.headers['content-disposition'];
            let filename = `${contactType}s_${new Date().toISOString().split('T')[0]}.xlsx`;

            if (contentDisposition) {
                const filenameMatch = contentDisposition.match(/filename="?(.+)"?/);
                if (filenameMatch.length === 2) {
                    filename = filenameMatch[1];
                }
            }

            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);

            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'success',
                title: `${contactType.charAt(0).toUpperCase() + contactType.slice(1)}s exported successfully!`,
                timer: 2000,
                timerProgressBar: false,
                showConfirmButton: false,
                didOpen: () => {
                    const container = Swal.getContainer();
                    container.style.top = '50px';
                },
            });

        } catch (error) {
            console.error('Export error:', error);
            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'error',
                title: `Failed to export ${contactType}s`,
                timer: 3000,
                timerProgressBar: false,
                showConfirmButton: false,
                didOpen: () => {
                    const container = Swal.getContainer();
                    container.style.top = '50px';
                },
            });
        } finally {
        }
    };


    return (
        <div className="main-content">
            <div className="page-content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12">
                            <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                                <h4 className="mb-sm-0 font-size-18">
                                    {type === 'client' ? 'Clients' : 'Vendors'}
                                </h4>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-body">
                                    <div className="d-flex justify-content-between mb-3">
                                        <div className="d-flex">
                                            <div className="search-box me-2 mb-2 d-inline-block">
                                                <div className="position-relative">
                                                    <input
                                                        type="text"
                                                        className="form-control font-size-12"
                                                        placeholder="Search..."
                                                        value={searchQuery}
                                                        onChange={handleSearchChange}
                                                    />
                                                    <i className="bx bx-search-alt search-icon" />
                                                </div>
                                            </div>
                                        </div>
                                         <div className="d-flex align-items-center gap-2">
                                                {/* Export Button */}
                                                <button
                                                    type="button"
                                                    className="btn btn-light border"
                                                    onClick={handleExport}
                                                    data-bs-toggle="tooltip"
                                                    data-bs-placement="top"
                                                    title="Export"
                                                >
                                                    <i className="mdi mdi-file-excel text-success"></i>
                                                </button>

                                                {/* Import Button */}
                                                <input
                                                    type="file"
                                                    accept=".xlsx, .xls"
                                                    id="importLeadsFile"
                                                    onChange={handleImport}
                                                    style={{ display: "none" }}
                                                />
                                                <label
                                                    htmlFor="importLeadsFile"
                                                    className="btn btn-light border mb-0"
                                                    data-bs-toggle="tooltip"
                                                    data-bs-placement="top"
                                                    title="Import"
                                                >
                                                    <i className="mdi mdi-upload text-primary"></i>
                                                </label>

                                            {/* Add Button */}
                                            <WithCreatePermission>
                                                <button
                                                    type="button"
                                                    className="btn rounded-circle border d-flex align-items-center justify-content-center round-create-button"
                                                    onClick={() => handleShowModal()}
                                                    data-bs-toggle="tooltip"
                                                    data-bs-placement="top"
                                                    title={`Add ${type === 'client' ? 'Client' : 'Vendor'}`}
                                                >
                                                    <i className="mdi mdi-plus"></i>
                                                </button>
                                            </WithCreatePermission>
                                        </div>
                                    

                                        {/* <WithCreatePermission>

                                            <button
                                                type="button"
                                                className="btn rounded-circle border d-flex align-items-center justify-content-center round-create-button"

                                                onClick={() => handleShowModal()}
                                                data-bs-toggle="tooltip"
                                                data-bs-placement="top"
                                                title={`Add ${type === 'client' ? 'Client' : 'Vendor'}`}
                                            >
                                                <i className="mdi mdi-plus" ></i>
                                            </button></WithCreatePermission> */}
                                    </div>

                                    <table className="table align-middle table-nowrap table-check table-list">

                                        <thead className="table-light">
                                            <tr>
                                                <th style={{ width: '20px' }} className="align-middle">
                                                    <div className="form-check font-size-16">
                                                        <input className="form-check-input" type="checkbox" id="checkAll" />
                                                        <label className="form-check-label" htmlFor="checkAll"></label>
                                                    </div>
                                                </th>
                                                <th className="align-middle">#</th>
                                                <th style={{ textAlign: "left" }}>{type === 'client' ? 'Client' : 'Vendor'}  ID</th>
                                                <th style={{ textAlign: "left" }}>Name</th>

                                                <th className="text-start" style={{ width: '10%' }}>Business Name</th>

                                                <th className="align-middle">Email</th>
                                                {type === 'vendor' && (
                                                    <th className="align-middle">RCM Eligible</th>
                                                )}

                                                <th className="align-middle">Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {contacts.length > 0 ? (
                                                contacts.map((client, index) => (
                                                    <tr key={client.id}>
                                                        <td>
                                                            <div className="form-check font-size-16">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="checkbox"
                                                                    id={`clientCheck${index}`}
                                                                />
                                                                <label
                                                                    className="form-check-label"
                                                                    htmlFor={`clientCheck${index}`}
                                                                ></label>
                                                            </div>
                                                        </td>
                                                        <td>{index + 1}</td>
                                                        <td style={{ textAlign: "left" }}>
                                                            <button
                                                                onClick={() => handleShowLeadDetails(client.id)} // Pass lead ID
                                                                className="dropdown-item"
                                                            >
                                                                {client.contact_id}
                                                            </button>
                                                        </td>
                                                        <td style={{ textAlign: "left" }}>{client.name}</td>
                                                        <td className="text-start" >{client.business_name}</td>

                                                        <td>{client.email}</td>
                                                        {type === 'vendor' && (
                                                            <td>{client.rcm_eligible ? 'Yes' : 'No'}</td>
                                                        )}
                                                        {/* <td>{client.mobile}</td> */}
                                                        <td>
                                                            <div className="dropdown">
                                                                <i
                                                                    className="mdi mdi-dots-horizontal font-size-18"
                                                                    data-bs-toggle="dropdown"
                                                                    aria-expanded="false"
                                                                    style={{ cursor: 'pointer' }}
                                                                ></i>
                                                                <ul className="dropdown-menu dropdown-menu-end font-size-14" >
                                                                    <li>
                                                                        <Link to={`/contacts/${contactType}/details/${client.id}`} className="dropdown-item">
                                                                            View Details
                                                                        </Link>
                                                                    </li>
                                                                    <li><WithEditPermission>
                                                                        <button
                                                                            className="dropdown-item"
                                                                            onClick={() => handleShowModal(client.id)}
                                                                        >
                                                                            Edit
                                                                        </button></WithEditPermission>
                                                                    </li>
                                                                    <li><WithDeletePermission>
                                                                        <button
                                                                            className="dropdown-item"
                                                                            onClick={() => deleteContact(client.id)}
                                                                        >
                                                                            Delete
                                                                        </button></WithDeletePermission>
                                                                    </li>

                                                                </ul>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan={type === 'vendor' ? 7 : 6} className="text-center">No clients found.</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                    <div className="d-flex justify-content-end pagination-sm">

                                        <ReactPaginate
                                            previousLabel={'<'}
                                            nextLabel={'>'}
                                            breakLabel={'...'}
                                            pageCount={pageCount}
                                            marginPagesDisplayed={2}
                                            pageRangeDisplayed={3}
                                            onPageChange={handlePageClick}
                                            containerClassName={'pagination pagination-rounded justify-content-end mb-2'}
                                            pageClassName={'page-item'}
                                            pageLinkClassName={'page-link'}
                                            previousClassName={'page-item previous'}
                                            previousLinkClassName={'page-link'}
                                            nextClassName={'page-item next'}
                                            nextLinkClassName={'page-link'}
                                            breakClassName={'page-item'}
                                            breakLinkClassName={'page-link'}
                                            activeClassName={'active'}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <ClientModal
                showModal={showModal}
                handleClose={handleCloseModal}
                clientId={selectedContactId}
                clientData={selectedContactData}
                addClient={addContact}
                editClient={editContact}
                clients={contacts}
                countries={countries}
                type={contactType}
                fetchCountries={fetchCountries}
                errors={errors}
                setErrors={setErrors}
                contacts={contacts}

            // clientIdError={clientIdError}

            />

            <ClientDetails
                show={showLeadOffcanvas}
                onHide={handleCloseLeadDetails}
                clientId={selectedContactId}
                // onOrganisationUpdate={fetchOrganisation} // Pass refresh function if needed
                type={type}
            />
        </div>

    );
};

export default ClientList;




